module.exports = __webpack_public_path__ + "static/main-c9f882f89e961a5426f3f2685c81faf0.jpg";